export default function onChange_TableBodyCheckBox(e, check, setCheck) {
  if (e.target.checked) {
    setCheck({ ...check, [e.target.name]: e.target.checked })
  } else {
    const obj = check
    delete obj[e.target.name]
    setCheck({ ...obj })
  }
}
